export const SET_IMAGE = "SET_IMAGE";
export const SET_SELECTED_IMAGES_DATA = "SET_SELECTED_IMAGES_DATA"
export const SET_CUSTOMIZE_IMAGES_DATA = "SET_CUSTOMIZE_IMAGES_DATA"
export const SET_SELECTED_IMAGES = "SET_SELECTED_IMAGES";
export const SET_TEXT = "SET_TEXT";
export const UPDATE_TEXT = "UPDATE_TEXT";
export const CROP_IMAGE = "CROP_IMAGE";
export const IMAGE_COORDINATE = "IMAGE_COORDINATE";

